module.exports = __webpack_public_path__ + "img/card_bg2.7bb1c8ac.png";